import DOMPurify from "dompurify";

export function sanitize(content: string): string {
    if (typeof window === "undefined") {
        // Server-side: use sanitize-html to avoid jsdom dependencies
        // We use require to ensure it is not bundled for the client
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const sanitizeHtml = require("sanitize-html");

        return sanitizeHtml(content, {
            allowedTags: sanitizeHtml.defaults.allowedTags.concat([
                'img', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div',
                'p', 'br', 'hr', 'ul', 'ol', 'li', 'b', 'i', 'strong', 'em',
                'a', 'blockquote', 'code', 'pre', 'table', 'thead', 'tbody',
                'tr', 'th', 'td', 'u', 's', 'del'
            ]),
            allowedAttributes: {
                // Allow classes and IDs for styling
                '*': ['class', 'style', 'id', 'title', 'data-*', 'aria-*', 'role'],
                'a': ['href', 'name', 'target', 'rel'],
                'img': ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading', 'decoding'],
                'iframe': ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen'] // Optional if you need embeds
            },
            // `style` used to pass through untouched on every tag (position:fixed overlays, url() beacons...). It is now
            // limited to the few properties the editor's tables really write (min-width / width on table and col, found in
            // the live articles) plus text alignment, each with a plain value (audit 2026-10-11, D7).
            allowedStyles: {
                '*': {
                    'width': [/^\d+(\.\d+)?(px|%|em|rem)$/],
                    'min-width': [/^\d+(\.\d+)?(px|%|em|rem)$/],
                    'max-width': [/^\d+(\.\d+)?(px|%|em|rem)$/],
                    'text-align': [/^(left|right|center|justify)$/],
                },
            },
            allowedSchemes: ['http', 'https', 'mailto', 'tel'],
            allowProtocolRelative: true
        });
    } else {
        // Client-side: use DOMPurify
        return DOMPurify.sanitize(content);
    }
}
